import { Typography } from "@mui/material"

interface Props {
  label: string,
  url: string
}

const Link = ({ label, url }: Props) => {
  return (
    <Typography fontFamily="Inter" fontSize={14} padding={0.1}>
      <a href={url} target="_blank" rel="noreferrer">
        {label}
      </a>
    </Typography>
  )
}

export default Link